/* eslint-disable */

import api from "api";
import { useAuth } from "context/auth";
import { useEsriUrls } from "context/esriUrlsContext";
import * as Tafgeet from "tafgeetjs";
import { handleLoading, useLoading } from "context/LoadingContext";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import extractCodesFromDlsKey from "utils/extractCodesFromDlsKey";
import { getHodAndVillNames } from "../../ParcelsSearch";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

/* eslint-disable react/jsx-curly-brace-presence */
function Fatoora(props) {
  const printRef = useRef();
  const [esriUrls] = useEsriUrls();
  const [auth] = useAuth();
  const fullName = `${auth?.userDetails?.details?.firstName} ${auth?.userDetails?.details?.lastName}`;

  const [address, setAddress] = useState({});
  const [peopleName, setPeopleName] = useState("");

  const [, loadingDispatch] = useLoading();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const { paymentLogItem } = props;

  useEffect(() => {
    (async () => {
      handleLoading(loadingDispatch, true);
      try {
        if (paymentLogItem) {
          const { vill, hod, parcel } = extractCodesFromDlsKey(
            paymentLogItem.dlsKey.trim()
          );

          const { villName, hodName } = await getHodAndVillNames({
            villCode: vill,
            hodCode: hod,
            villLayerId: esriUrls.villagesLookup,
            hodLayerId: esriUrls.hodesLookUp,
            token: auth.esriToken,
          });

          setAddress({ villName, hodName, parcel });
        }
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
      try {
        const res = await api.post("users/userNameByNat", {
          natNumber: paymentLogItem.nationalNumber,
        });
        setPeopleName(res.data.data.arabicName);
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
      handleLoading(loadingDispatch, false);
    })();
  }, [paymentLogItem]);

  return (
    <>
      <button
        type="button"
        className="table__export btn btn--primary me-2"
        onClick={handlePrint}
      >
        <i className="fa-solid fa-print clickable" key="export" />
      </button>
      <div
        ref={printRef}
        style={{ marginInline: "1cm" }}
        className="print-page"
      >
        {/*  */}
        <div className="text-center print-page__header">
          <img
            className="my-3"
            src={`${process.env.PUBLIC_URL}/imgs/jordan-logo.png`}
            style={{ width: "75pt", aspectRatio: "1/1" }}
            alt=""
          />
          <h4>المملكة الأردنية الهاشمية</h4>
          <h4>سلطة اقليم البترا التنموي السياحي</h4>
          <h4>وصل مقبوضات فرعي</h4>
          <h4>مستند قبض</h4>
        </div>
        <div className="print-page__body">
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <p>
              التاريخ:<span>{paymentLogItem.paymentDateIso}</span>
            </p>
            <p>
              رقم سند القبض:<span>{paymentLogItem.receiptNumber}</span>
            </p>
          </div>
          {/*  */}
          <p>وصلني من:{peopleName || paymentLogItem.applicant}</p>
          <p>
            مبلغ و قدره بالدينار:
            {/* <input className="print-no-border" type="text" /> */}
            {`(${paymentLogItem.price} ${
              paymentLogItem.price > 1 ? "دنانير" : "دينار"
            }) `}
            {new Tafgeet(paymentLogItem.price, "TND")
              .parse()
              .replace("تونسي", "أردني")
              .replace("فقط ", "")
              .replace("لا غير", "فقط لا غير")
              .replace("مليم", "قروش")}
          </p>
          <p>
            و ذلك عن <span style={{ fontWeight: 600 }}>مخطط موقع و ترسيم</span>
          </p>
          <table
            className="table"
            border="1"
            style={{ "--primary-light": "black", clipPath: "unset" }}
          >
            <tr>
              <th>البيان</th>
              <th style={{ width: "1px", whiteSpace: "nowrap" }}>
                المبلغ بالدينار
              </th>
            </tr>
            <tr>
              <td>
                رسوم مخطط موقع و ترسيم: قرية
                <span>
                  {address?.villName}, حوض <span>{address?.hodName}</span> , ارض
                  <span>{address?.parcel}</span>
                </span>
              </td>
              <td
                style={{
                  width: "1px",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                {parseFloat(paymentLogItem.price)}
              </td>
            </tr>
          </table>
          <div className="mt-3 d-flex">
            <p style={{ alignSelf: "center", marginInlineStart: "auto" }}>
              المجموع
            </p>
            <table
              className="table "
              border="1"
              style={{
                "--primary-light": "black",
                clipPath: "unset",
                width: "133px",
                marginInlineStart: "1rem",
              }}
            >
              <tr>
                <td
                  style={{
                    width: "1px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  {parseFloat(paymentLogItem.price)}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="print-page__footer">
          <div
            className="mt-3 d-flex"
            style={{ gap: ".8rem", alignItems: "flex-end" }}
          >
            <p>اسم و توقيع المستلم</p>
            <p style={{ borderBottom: "dotted 1px black", flex: 1 }} />
            <p style={{ borderBottom: "dotted 1px black", flex: 1 }} />
          </div>
          <div className="mt-3">
            <p>اسم و ختم امين الصندوق دفع الكتروني اي فواتيركم</p>
          </div>
          <div className="mt-3 grid grid-of-2">
            <p>
              طبع بواسطة:
              <span>{fullName}</span>
            </p>
            <p>
              رقم الدفع:
              <span>{paymentLogItem.ePaymentNumber}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

Fatoora.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  paymentLogItem: PropTypes.object.isRequired,
};

export default Fatoora;

/* <p className="d-flex mt-3" style={{ gap: "16px" }}>
<span>اسم و توقيع المستلم</span>
</p>
<p className="d-flex mt-3" style={{ gap: "16px" }}>
<p style={{ borderBottom: "1px dotted black", width: "100%" }} />
<p style={{ borderBottom: "1px dotted black", width: "100%" }} />
</p>
<p>قسم و ختم أمين الصندوق</p>
<p>طبع بواسطة : {user}</p> */
